export default __webpack_public_path__ + "assets/enterprise-one-five-small.fc1d96c785f71bea47681d880e3e2614.png";